import React from 'react';
import { XIcon } from 'lucide-react';
import { notForYou } from '../data/masterclass';
export function WhoThisIsNotFor() {
  return <section aria-labelledby="not-for-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-154" data-mp="2f5c09cjicfrl">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-155" data-mp="2b5jqiwido3kn">
        <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-156" data-mp="267i4q3tkhq5h">
          Who this is not for
        </p>
        <h2 id="not-for-heading" className="mt-4 max-w-3xl font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-157" data-mp="32voe141fp6q3">
          Unified Success is not for everybody.
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-158" data-mp="2owoolu63knsv">
          {notForYou.lines.map(line => <li key={line} className="flex items-start gap-4 rounded-2xl border border-ink-line bg-ink p-7 text-xl leading-snug text-white/70" data-id="element-159" data-mp="1igcqtu76t7xt">
              <XIcon className="mt-1 h-5 w-5 shrink-0 text-gold/60" aria-hidden="true" data-id="element-160" data-mp="22c531a3y9hsq" />
              <span data-id="element-161" data-mp="22aagjrd15hmj">{line}</span>
            </li>)}
        </ul>

        <p className="mt-10 font-display text-3xl font-semibold uppercase leading-snug text-gold sm:text-4xl" data-id="element-162" data-mp="26d6tb1fw2jik">
          {notForYou.close}
        </p>
      </div>
    </section>;
}